'use strict'
;

(function($) {

  $('.main-carousel').flickity({
    // options
    cellAlign: 'right',
    contain: true,
    pageDots: false,
    wrapAround: true,
  });

  $('.testimonials_slider').flickity({
    // options
    cellAlign: 'center',
    contain: true,
    pageDots: true,
  });

})(jQuery)
